import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../api";
import { useAuth } from "./AuthContext";

const SubscriptionsContext = createContext();

export const SubscriptionsProvider = ({ children }) => {
  const { user } = useAuth();
  const [subs, setSubs] = useState([]);
  const [spots, setSpots] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(() => {
    if (!user) { setSubs([]); setSpots([]); setLoaded(true); return; }
    setLoaded(false);
    api.get("/my/subscriptions").then((r) => setSubs(r.data || [])).catch(() => setSubs([])).finally(() => setLoaded(true));
    api.get("/my/spot-follows").then((r) => setSpots(r.data || [])).catch(() => setSpots([]));
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isFollowing = (business) => subs.includes(business);

  const toggleFollow = async (business) => {
    if (isFollowing(business)) {
      setSubs((p) => p.filter((b) => b !== business));
      try { await api.post("/subscriptions/unfollow", { business }); } catch { refresh(); }
      return false;
    }
    setSubs((p) => [...p, business]);
    try { await api.post("/subscriptions", { business }); } catch { refresh(); }
    return true;
  };

  const isFollowingSpot = (coord) => spots.some((s) => s.coord === coord);

  const toggleFollowSpot = async (coord, meta = {}) => {
    if (isFollowingSpot(coord)) {
      setSpots((p) => p.filter((s) => s.coord !== coord));
      try { await api.post(`/spots/${coord}/unfollow`); } catch { refresh(); }
      return false;
    }
    setSpots((p) => [...p, { coord, ...meta }]);
    try { await api.post(`/spots/${coord}/follow`); } catch { refresh(); }
    return true;
  };

  return (
    <SubscriptionsContext.Provider value={{ subs, spots, loaded, isFollowing, toggleFollow, isFollowingSpot, toggleFollowSpot, refresh }}>
      {children}
    </SubscriptionsContext.Provider>
  );
};

export const useSubscriptions = () => useContext(SubscriptionsContext);
